
export enum EstadoCivilEnum {
  Solteiro = 'Solteiro',
  Casado = 'Casado',
  Divorciado = 'Divorciado',
  Viúvo = 'Viúvo',
  UniaoEstavel = 'UniaoEstavel',
}
